import { render, staticRenderFns } from "./TaskFormats.vue?vue&type=template&id=6c8ed47e&scoped=true"
import script from "./TaskFormats.vue?vue&type=script&lang=js"
export * from "./TaskFormats.vue?vue&type=script&lang=js"
import style0 from "./TaskFormats.vue?vue&type=style&index=0&id=6c8ed47e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ed47e",
  null
  
)

export default component.exports